import { useState, useEffect } from 'react'
import { SelectionBox, SearchBox } from '../Components/InputBox'
import { PersonBatterFrame } from '../Components/Frame'
import { extractDataByBatter } from '../Utils/DataProcessBatter'
import { extractPlayByPlayData, resolveSheetDataBatter } from '../Utils/DataProcess'
import { extractPlayerList } from '../Utils/PlayerListProcess'
import { PlayerList } from '../Components/PlayerList'

const PersonBatter = ({ data, loading }) => {

  const [player, setPlayer] = useState('')
  const handleOnSelect = (e) => {
    setPlayer(e.target.value)
    setTeststatPR(leaderBoardBatterData.teststatPR.filter(data => data.Player === e.target.value))
  }
  const handleOnClickName = (e) => {
    setPlayer(e.name)
    setTeststatPR(leaderBoardBatterData.teststatPR.filter(data => data.Player === e.name))
  }
  const [batterData, setBatterData] = useState({ batterList: [], dataByBatter: {}, plays: [] })
  const [leaderBoardBatterData, setLeaderBoardBatterData] = useState({ teststat: [], teststatPR: [], teststatPR_Comp: [] })
  const [teststatPR, setTeststatPR] = useState()
  const [anglePR, setAnglePR] = useState({})
  const [volePR, setVolePR] = useState({})
  const [allPlayers, setAllPlayers] = useState({idMap:{}, names: [], ids: [],})
  const [search, setSearch] = useState('')

  useEffect(() => {
    if (!loading) {
      var OZone = data.find(e => e.id === '2021OZone').data
      OZone.forEach(oz=>{
        oz.Av_Angle = parseFloat(oz.Av_Angle)
        oz.Av_EV = parseFloat(oz.Av_EV)
        // console.log(oz)
      })

      const ZoneAll = ['Ozone1', 'Ozone2', 'Ozone3', 'Ozone4', 'Zone1', 'Zone2', 'Zone3', 'Zone4', 'Zone5', 'Zone6', 'Zone7', 'Zone8', 'Zone9']

      let anglePR = {}
      let volePR = {}
      ZoneAll.forEach(z => {
        var za = OZone.filter(e => e.O_Zone === z)
        anglePR[z] = []
        volePR[z] = []
        za.forEach(item => {
          anglePR[z].push({ player: '', val: item.Av_Angle, rank: 0 })
          volePR[z].push({ player: '', val: item.Av_EV, rank: 0 })
        })
      })

      setAnglePR(anglePR)
      setVolePR(volePR)
      setAllPlayers(extractPlayerList('batter', data[4].data))
      setBatterData({...extractDataByBatter(data[0].data, data[1].data), plays: extractPlayByPlayData(data[0].data, data[1].data).batterPlays})
      setLeaderBoardBatterData(resolveSheetDataBatter(data[0].data, data[1].data, data[5].data))
    }
  }, [loading])

  const filterOutSearchResult = (s, valid) => {
    if (s === '' || s[0] === undefined) return valid
    let output = []
    for (const i of valid) {
      if (i.includes(s)) output.push(i)
    }
    return output
  }

  return (
    <>
      <div className="wrapper">
        <div className='page_menu'>
          <div className='page_menu_title'>選手名稱</div>
          <div className='page_header_select'>
            <SelectionBox val={player} placeholder='請選擇' options={batterData.batterList} handleSelect={handleOnSelect} loading={loading} />
          </div>
          <div className='page_menu_searchbox'>
            <SearchBox placeholder='搜尋選手' onClick={(val)=>{setSearch(val)}} />
          </div>
          <div className='page_menu_back_block'>
            <button className='page_menu_back_button' onClick={()=>{setPlayer(''); setSearch('');}}>回點將錄</button>
          </div>
        </div>
        <div className='wrap setin'>
          <div className='person_score'>
            <div className='title_frame'>
              <div className='title'>打者個人</div>
            </div>
          </div>
        </div>
      </div>
      <div className='wrapper bg_gray'>
        {
          (player === '' || player[0] === undefined)?
          <PlayerList type='batter' allPlayers={allPlayers} validPlayers={filterOutSearchResult(search ,batterData.batterList)} handleOnClick={handleOnClickName} />: 
          <PersonBatterFrame type='personBatter' data={batterData.dataByBatter[player]} teststatPR={teststatPR} anglePR={anglePR} volePR={volePR} plays={batterData.plays[player]} />
        }
      </div>
    </>
  )
}

export default PersonBatter